import Api from '@/api';

const loginUser = (context, user) => new Promise((resolve, reject) => {
  Api.authService.authorize(user.username, user.password)
    .then(response => {
      context.commit('setUser', response.data);
      Api.authService.setAuthToken(response.data.access_token);
      Api.authService.setRefreshToken(response.data.refresh_token);
      resolve(response.data);
    })
    .catch(error => reject(error.data));
});

export default {
  loginUser,
};
